/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Add_ThisInputs */

const en_us2_swap_add_this = /** @type {(inputs: Swap_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const pt_br2_swap_add_this = /** @type {(inputs: Swap_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar`)
};

const es_419_swap_add_this = /** @type {(inputs: Swap_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar`)
};

const pt_pt2_swap_add_this = /** @type {(inputs: Swap_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar`)
};

const fr_fr2_swap_add_this = /** @type {(inputs: Swap_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

const de_de2_swap_add_this = /** @type {(inputs: Swap_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

const it_it2_swap_add_this = /** @type {(inputs: Swap_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Swap_Add_ThisInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_add_this = /** @type {((inputs?: Swap_Add_ThisInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Add_ThisInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_add_this(inputs)
	if (locale === "es-419") return es_419_swap_add_this(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_add_this(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_add_this(inputs)
	if (locale === "de-DE") return de_de2_swap_add_this(inputs)
	if (locale === "it-IT") return it_it2_swap_add_this(inputs)
	return en_us2_swap_add_this(inputs)
});
export { swap_add_this as "swap.add_this" }